export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  readTime: number;
}

export const articles: Article[] = [
  {
    slug: 'guochan-dianying-jueqi-2025',
    title: '国产电影的崛起之路：2025年度精品佳作盘点',
    excerpt: '回顾2025年国产电影的辉煌成就，从票房黑马到口碑佳作，中国电影产业正在经历一场前所未有的变革与繁荣。',
    content: `<p>2025年，中国电影市场迎来了一波令人瞩目的精品浪潮。从春节档的开门红到暑期档的百花齐放，国产电影不仅在票房上屡创新高，更在艺术品质上实现了质的飞跃。</p>
    <h3>票房与口碑双丰收</h3>
    <p>据国家电影局统计，2025年上半年国产电影总票房突破400亿元，同比增长15%。其中多部作品凭借扎实的剧本、精良的制作和深刻的人文关怀赢得了观众的广泛认可。《山河故人》以9.2分的豆瓣评分成为年度口碑之冠，其细腻的叙事和深刻的家国情怀打动了无数观众。</p>
    <h3>类型片的突破与创新</h3>
    <p>科幻电影领域，《星际之门》以世界级的视觉特效和东方哲学内核，标志着中国科幻电影进入新纪元。动画电影《长安三万里》续作以更加成熟的技术和叙事，再次证明了国产动画的无限潜力。悬疑片《迷雾追踪》则以精巧的结构和出人意料的结局，成为年度黑马。</p>
    <h3>新生代导演的力量</h3>
    <p>2025年也是新生代导演大放异彩的一年。一批85后、90后导演带着独特的视角和创新的表达方式，为中国电影注入了新鲜血液。他们的作品既有对传统的传承，也有对现代的思考，展现出中国电影人的文化自信和创新精神。</p>
    <p>展望未来，中国电影产业正处于最好的发展时期。随着制作水平的不断提升和创作环境的持续优化，我们有理由相信，国产电影将继续在世界影坛书写属于自己的精彩篇章。</p>`,
    category: '影视精品',
    categorySlug: 'yingshi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20modern%20film%20studio%20with%20professional%20lighting%20equipment%20and%20movie%20posters%2C%20cinematic%20atmosphere%2C%20warm%20golden%20tones%2C%20elegant%20cultural%20aesthetic%2C%20high%20quality%20editorial%20photography&width=800&height=500&seq=article-yingshi-1&orientation=landscape',
    author: '林晓峰',
    date: '2025-12-15',
    views: 128600,
    tags: ['国产电影', '电影产业', '票房', '文化自信'],
    readTime: 8,
  },
  {
    slug: 'huayu-wenxue-jingdian-tuijian',
    title: '华语文学新经典：十部不可错过的原创佳作',
    excerpt: '从茅盾文学奖获奖作品到网络文学精品，当代华语文学创作呈现出蓬勃生机，我们为您精选十部不可错过的优秀作品。',
    content: `<p>当代华语文学正处于一个前所未有的繁荣期。传统文学与网络文学的边界日益模糊，严肃文学与类型文学相互渗透，催生了一大批兼具思想深度和阅读趣味的优秀作品。</p>
    <h3>茅盾文学奖获奖作品精选</h3>
    <p>第十一届茅盾文学奖获奖作品《山河入梦》以宏大的历史视野和细腻的人物刻画，描绘了中国近现代史上波澜壮阔的社会变迁。作者用诗意的语言和严谨的叙事，构建了一个令人难忘的文学世界。</p>
    <h3>网络文学精品化转型</h3>
    <p>《长安十二时辰》等网络文学作品的成功，标志着网络文学正在经历一场精品化转型。越来越多的网络作家开始注重文学品质的提升，在保持故事吸引力的同时，融入了更深层次的文化思考和人文关怀。</p>
    <h3>新生代作家的崛起</h3>
    <p>90后、00后作家群体正在以独特的视角和表达方式，为华语文学注入新鲜活力。他们的作品更加关注个体命运与时代变迁的关系，语言风格更加多元化和个性化，展现了新一代作家的创作实力。</p>
    <p>在这个信息爆炸的时代，阅读优秀的文学作品依然是人们获得精神滋养的重要途径。希望这份推荐清单能够帮助读者发现更多优秀的华语文学作品。</p>`,
    category: '文学佳作',
    categorySlug: 'wenxue',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20literature%20books%20on%20a%20wooden%20desk%20with%20warm%20reading%20lamp%2C%20elegant%20study%20room%2C%20calligraphy%20brush%2C%20scholarly%20atmosphere%2C%20soft%20natural%20light%2C%20cultural%20aesthetic&width=800&height=500&seq=article-wenxue-1&orientation=landscape',
    author: '苏婉清',
    date: '2025-11-28',
    views: 95300,
    tags: ['华语文学', '原创文学', '茅盾文学奖', '阅读推荐'],
    readTime: 10,
  },
  {
    slug: 'zhongguo-yinyue-chuangzuo-xinchao',
    title: '中国音乐创作新潮：从国风到世界的声音',
    excerpt: '从传统国风到现代融合，中国音乐人正在用创新的方式让世界听见中国声音。深度解析当下华语乐坛的创作趋势。',
    content: `<p>近年来，中国音乐创作领域涌现出了一股强劲的创新浪潮。从传统国风音乐到现代电子融合，从独立音乐到主流流行，中国音乐人正在以更加自信和开放的姿态走向世界舞台。</p>
    <h3>国风音乐的现代化转型</h3>
    <p>国风音乐不再局限于传统的编曲和演唱方式。新一代音乐人将电子音乐、爵士乐甚至嘻哈元素融入国风创作中，创造出令人耳目一新的听觉体验。《万疆》、《兰亭序》等作品的成功证明了这种创新的市场潜力和艺术价值。</p>
    <h3>独立音乐的蓬勃发展</h3>
    <p>中国独立音乐场景日益繁荣，大量优秀的独立音乐人和乐队涌现。他们以独特的音乐语言和真诚的表达，吸引了越来越多的忠实听众。从后摇滚到民谣，从实验电子到世界音乐，中国独立音乐的多元化和高质量令人欣喜。</p>
    <h3>音乐与科技的融合</h3>
    <p>AI音乐创作、虚拟偶像、沉浸式音乐体验等前沿领域的探索，为中国音乐产业带来了新的可能性。越来越多的音乐人开始拥抱新技术，在创作、制作和演出的各个环节融入科技元素。</p>
    <p>中国音乐正在经历一个百花齐放的黄金时代。我们有理由期待，未来将有更多优秀的中国音乐作品走向世界。</p>`,
    category: '音乐鉴赏',
    categorySlug: 'yinyue',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20music%20instruments%20guzheng%20and%20modern%20studio%20setup%2C%20artistic%20composition%2C%20warm%20lighting%2C%20elegant%20cultural%20atmosphere%2C%20professional%20photography&width=800&height=500&seq=article-yinyue-1&orientation=landscape',
    author: '周明远',
    date: '2025-11-20',
    views: 87200,
    tags: ['华语音乐', '国风音乐', '独立音乐', '音乐创作'],
    readTime: 7,
  },
  {
    slug: 'rengong-zhineng-zhongguo-tupo',
    title: '中国人工智能技术突破：从追赶者到引领者',
    excerpt: '中国AI企业在自然语言处理、计算机视觉、自动驾驶等领域取得重大突破，正从全球技术追赶者转变为创新引领者。',
    content: `<p>2025年，中国人工智能产业迎来了里程碑式的突破。在多个核心技术领域，中国企业从曾经的追赶者逐步成长为全球创新的引领者。</p>
    <h3>大模型技术的突破</h3>
    <p>多家中国科技企业推出的大语言模型在多项国际评测中取得了卓越成绩。这些模型不仅在中文处理能力上具有天然优势，在多语言理解和生成方面也展现出强大的竞争力。开源生态的完善进一步加速了AI技术的普及和应用创新。</p>
    <h3>AI+产业的深度融合</h3>
    <p>人工智能正深度融入制造、医疗、教育、金融等各行各业。在智能制造领域，AI驱动的质量检测系统将产品缺陷率降低了超过60%；在医疗领域，AI辅助诊断系统在早期癌症筛查中的准确率已经达到专家级水平。</p>
    <h3>自动驾驶的商业化提速</h3>
    <p>多个城市的自动驾驶出租车服务已经进入规模化运营阶段。激光雷达、高精度地图、决策算法等核心技术的持续突破，使中国在自动驾驶领域保持全球领先地位。</p>
    <p>中国AI产业的快速发展得益于良好的创新生态、丰富的数据资源和庞大的应用市场。持续的技术创新将为经济社会发展注入更强劲的动力。</p>`,
    category: '科技创新',
    categorySlug: 'keji',
    image: 'https://readdy.ai/api/search-image?query=Modern%20AI%20technology%20lab%20with%20holographic%20displays%20and%20clean%20minimalist%20design%2C%20futuristic%20Chinese%20tech%20office%2C%20warm%20ambient%20lighting%2C%20professional%20corporate%20photography&width=800&height=500&seq=article-keji-1&orientation=landscape',
    author: '陈志远',
    date: '2025-12-08',
    views: 113400,
    tags: ['人工智能', '科技创新', '大模型', '自动驾驶'],
    readTime: 9,
  },
  {
    slug: 'guochao-shenghuo-meixue-zhinan',
    title: '国潮生活美学指南：在日常中发现东方韵味',
    excerpt: '从家居陈设到日常穿搭，从茶道花艺到饮食文化，国潮美学正在重新定义中国人的品质生活方式。',
    content: `<p>国潮不仅仅是一种时尚潮流，更是一种生活态度的回归。越来越多的中国人开始在日常生活中融入东方美学元素，创造属于自己的品质生活空间。</p>
    <h3>新中式家居美学</h3>
    <p>新中式家居风格不再是简单的中式元素堆砌，而是将传统美学精神与现代生活方式巧妙融合。通过留白的空间布局、天然材料的运用和光影的巧妙设计，营造出既有东方意境又不失现代舒适感的居住空间。</p>
    <h3>茶文化与生活仪式感</h3>
    <p>茶文化在年轻群体中的复兴令人欣喜。从传统的功夫茶到创新的新式茶饮，茶正在成为一种连接传统与现代的生活方式。越来越多的人开始学习茶道，在泡茶、品茶的过程中寻找内心的宁静。</p>
    <h3>东方美学的日常穿搭</h3>
    <p>改良汉服、新中式服饰等正在从小众走向主流。设计师们将传统服饰的元素与现代剪裁技术相结合，创造出兼具东方韵味和时尚感的日常穿搭方案。</p>
    <p>国潮美学不是复古，而是一种将传统智慧融入现代生活的探索。在这个过程中，每个人都可以找到属于自己的东方生活之美。</p>`,
    category: '生活美学',
    categorySlug: 'shenghuo',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20tea%20ceremony%20with%20elegant%20teaware%20and%20minimalist%20interior%2C%20warm%20natural%20light%2C%20zen%20atmosphere%2C%20artistic%20lifestyle%20photography&width=800&height=500&seq=article-shenghuo-1&orientation=landscape',
    author: '林雅琴',
    date: '2025-12-01',
    views: 76800,
    tags: ['国潮美学', '新中式', '茶文化', '生活品质'],
    readTime: 6,
  },
  {
    slug: 'sichou-zhilu-wenhua-tansuo',
    title: '丝绸之路文化探索：千年文明交流的当代回响',
    excerpt: '丝绸之路不仅是古代商贸通道，更是文明交流的桥梁。从历史文物到当代艺术，我们重新发现这条古老道路的文化价值。',
    content: `<p>丝绸之路承载着两千多年的文明交流史。从长安到罗马，这条古老的贸易路线不仅连接了东西方的商品，更传递了思想、艺术和信仰。</p>
    <h3>敦煌文化的现代解读</h3>
    <p>敦煌莫高窟作为丝绸之路上最璀璨的文化明珠，其壁画和雕塑艺术至今仍令人叹为观止。近年来，数字敦煌项目的推进让更多人能够以全新的方式体验这一文化瑰宝。虚拟现实技术让远在千里之外的人们也能身临其境地感受敦煌艺术之美。</p>
    <h3>丝路考古新发现</h3>
    <p>2025年，考古学家在新疆、甘肃等地有了多项重要发现。新出土的文物进一步丰富了我们对于丝绸之路上多元文化交流的理解。来自不同文明的器物在同一遗址中出现，生动地展示了古代文明交融的景象。</p>
    <h3>一带一路的文化新篇章</h3>
    <p>当代的"一带一路"倡议延续了古代丝绸之路的精神。文化交流项目、艺术展览、学术合作等活动正在搭建新的文明对话平台。这不仅是对历史的致敬，更是对未来文明交流的期许。</p>
    <p>丝绸之路的故事还远未结束。在这个全球化的时代，我们需要从历史中汲取智慧，促进不同文明之间的相互理解和尊重。</p>`,
    category: '历史人文',
    categorySlug: 'lishi',
    image: 'https://readdy.ai/api/search-image?query=Dunhuang%20Mogao%20Caves%20ancient%20Chinese%20art%20with%20warm%20desert%20tones%2C%20Silk%20Road%20cultural%20heritage%2C%20historical%20architecture%2C%20artistic%20photography%20with%20soft%20golden%20light&width=800&height=500&seq=article-lishi-1&orientation=landscape',
    author: '赵文博',
    date: '2025-11-15',
    views: 69400,
    tags: ['丝绸之路', '敦煌', '历史文化', '文明交流'],
    readTime: 8,
  },
  {
    slug: 'guoman-donghua-pinpai-jueqi',
    title: '国漫动画的品牌崛起：从《哪吒》到全球IP',
    excerpt: '中国动漫产业正在经历品牌化的关键转型期，从单一爆款到持续IP运营，国漫正在构建自己的全球影响力。',
    content: `<p>从《大圣归来》到《哪吒之魔童降世》，再到《长安三万里》，中国动画电影用一部部精品证明了自己的实力。如今，国漫正在从单一作品的成功走向品牌化和IP化的可持续发展道路。</p>
    <h3>IP全产业链开发</h3>
    <p>成功的国漫IP不再局限于电影票房，而是向游戏、衍生品、主题乐园、线下展览等全产业链延伸。《哪吒》系列的衍生品销售额已突破50亿元，展现了国漫IP强大的商业变现能力。</p>
    <h3>技术水平的飞跃</h3>
    <p>国产动画的制作水平在过去五年间实现了质的飞跃。从建模、渲染到动作捕捉，中国动画工作室已经具备了与国际一流团队竞争的技术实力。自主研发的渲染引擎和制作工具也在不断成熟。</p>
    <h3>内容创作的多元化</h3>
    <p>国漫的题材正从传统神话向更加多元化的方向发展。科幻、悬疑、现实主义、都市情感等题材的动画作品不断涌现，满足了不同年龄段观众的多样化需求。</p>
    <p>国漫正在书写属于自己的精彩故事。随着创作生态的不断完善和国际化步伐的加快，我们有理由相信国漫IP将在全球舞台上大放异彩。</p>`,
    category: '影视精品',
    categorySlug: 'yingshi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20digital%20drawing%20tablets%20and%20concept%20art%20on%20walls%2C%20creative%20workspace%2C%20warm%20colorful%20atmosphere%2C%20artistic%20photography&width=800&height=500&seq=article-yingshi-2&orientation=landscape',
    author: '王晓宇',
    date: '2025-12-05',
    views: 105200,
    tags: ['国漫', '动画电影', 'IP运营', '文化产业'],
    readTime: 7,
  },
  {
    slug: 'wangluo-wenxue-jingpin-hua',
    title: '网络文学精品化之路：从流量至上到内容为王',
    excerpt: '中国网络文学正在经历一场深刻的变革，从追求点击量为先转向注重作品品质，一批兼具文学价值和市场表现的作品脱颖而出。',
    content: `<p>中国网络文学经过二十多年的发展，已经形成了全球最大的网络文学市场。然而，近年来行业正在经历一场深刻的变革——从"流量至上"向"内容为王"的转型。</p>
    <h3>精品化转型的驱动力</h3>
    <p>读者审美水平的提升、监管政策的引导和市场竞争的加剧，共同推动了网络文学的精品化进程。越来越多的平台开始重视作品质量，设立专门的内容审核和编辑团队，从源头上把控作品质量。</p>
    <h3>IP改编的反向推动</h3>
    <p>影视、游戏、动漫等下游产业的IP需求，反向推动了网络文学创作质量的提升。一部优秀的网络文学作品如果能够成功转化为影视作品，其商业价值和文化影响力都将得到倍增。</p>
    <h3>类型文学的丰富与创新</h3>
    <p>现实题材的崛起是近年来网络文学最大的亮点之一。从工业题材到乡村振兴，从科技创新到传统文化，网络文学正在以更加丰富的视角描绘当代中国社会。</p>
    <p>精品化不是对网络文学特色的否定，而是在保持其独特魅力的基础上实现品质的提升。这才是网络文学可持续发展的正确方向。</p>`,
    category: '文学佳作',
    categorySlug: 'wenxue',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cozy%20reading%20space%20with%20digital%20tablet%20and%20traditional%20books%2C%20warm%20lighting%2C%20creative%20writing%20atmosphere%2C%20literary%20aesthetic%2C%20soft%20natural%20tones&width=800&height=500&seq=article-wenxue-2&orientation=landscape',
    author: '张思源',
    date: '2025-11-25',
    views: 82100,
    tags: ['网络文学', 'IP改编', '精品化', '现实题材'],
    readTime: 8,
  },
  {
    slug: 'zhongguo-minyao-xinliang',
    title: '中国民谣新力量：从街头唱到万人场馆',
    excerpt: '民谣音乐正在中国经历一场复兴运动，独立民谣音乐人用真诚的音乐和诗意的歌词打动了数百万听众的心。',
    content: `<p>十年前，民谣还是一个小众的音乐门类。如今，中国民谣音乐已经发展成为一股不可忽视的文化力量。从Livehouse的小舞台到万人体育馆的大舞台，民谣音乐人正在书写属于自己的传奇。</p>
    <h3>民谣音乐人的代际更替</h3>
    <p>新一代民谣音乐人有着不同于前辈的成长背景和音乐训练。他们多数受过专业音乐教育，对世界音乐有着广泛的了解，同时保持着对中国本土文化的深厚感情。这使他们的创作既有国际视野，又饱含中国味道。</p>
    <h3>音乐节的助推效应</h3>
    <p>音乐节的蓬勃发展为民谣音乐提供了重要的展示平台。在全国各地举办的音乐节上，民谣音乐人获得了与更多观众面对面交流的机会。这种现场演出的体验，让民谣音乐的情感力量得到了最直接的传达。</p>
    <h3>新媒体时代的民谣传播</h3>
    <p>短视频平台和流媒体服务改变了民谣音乐的传播方式。一首优秀的民谣歌曲可以在短时间内通过社交媒体触及数百万听众。《成都》、《南山南》等作品的成功正是新媒体传播力量的体现。</p>
    <p>民谣音乐的魅力在于它的真诚和质朴。在这个快节奏的时代，民谣为人们提供了一个放慢脚步、聆听内心的机会。</p>`,
    category: '音乐鉴赏',
    categorySlug: 'yinyue',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20folk%20musician%20playing%20acoustic%20guitar%20on%20stage%20with%20warm%20stage%20lights%2C%20intimate%20concert%20atmosphere%2C%20artistic%20performance%20photography&width=800&height=500&seq=article-yinyue-2&orientation=landscape',
    author: '刘雨桐',
    date: '2025-12-10',
    views: 73700,
    tags: ['民谣音乐', '独立音乐', '音乐节', '原创音乐'],
    readTime: 6,
  },
  {
    slug: 'xin-nengyuan-chanye-zhongguo',
    title: '中国新能源产业的全球领跑之路',
    excerpt: '从光伏到锂电池，从风电到新能源汽车，中国新能源产业已在多个细分领域实现全球领先，正加速推动全球能源转型。',
    content: `<p>在全球能源转型的大背景下，中国新能源产业实现了跨越式发展。从上游原材料到下游应用，中国已经构建了全球最完整的新能源产业链。</p>
    <h3>光伏产业的全球主导地位</h3>
    <p>中国光伏产业在全球市场的份额已超过80%。从硅料到组件，中国企业在技术、成本和规模方面均具有显著优势。N型电池技术的突破进一步提升了中国光伏产品的竞争力，转换效率不断刷新世界纪录。</p>
    <h3>动力电池的王者之路</h3>
    <p>以宁德时代、比亚迪为代表的中国动力电池企业在全球市场占据了主导地位。固态电池、钠离子电池等下一代电池技术的研发也处于全球领先水平。中国动力电池产业链的完善程度和成本控制能力令竞争对手望尘莫及。</p>
    <h3>新能源汽车的全球化布局</h3>
    <p>中国新能源汽车品牌的国际化步伐明显加快。比亚迪、蔚来、小鹏等品牌在欧洲、东南亚等市场取得了显著进展。中国新能源汽车凭借出色的产品力和性价比，正赢得越来越多海外消费者的认可。</p>
    <p>新能源产业的蓬勃发展不仅为中国经济注入了新动力，也为全球应对气候变化做出了重要贡献。这是一条值得骄傲的领跑之路。</p>`,
    category: '科技创新',
    categorySlug: 'keji',
    image: 'https://readdy.ai/api/search-image?query=Modern%20solar%20panel%20farm%20with%20clean%20energy%20technology%2C%20sustainable%20innovation%2C%20bright%20natural%20light%2C%20professional%20industrial%20photography&width=800&height=500&seq=article-keji-2&orientation=landscape',
    author: '杨光耀',
    date: '2025-11-30',
    views: 98400,
    tags: ['新能源', '光伏产业', '动力电池', '新能源汽车'],
    readTime: 8,
  },
  {
    slug: 'zhongguo-chuantong-yinshi-xiandai',
    title: '中国传统饮食的现代化演绎：从宫廷御膳到新派中餐',
    excerpt: '中国饮食文化博大精深，当代厨师们正在用创新手法重新诠释传统味道，让千年美食以崭新的面貌呈现在现代餐桌之上。',
    content: `<p>中国饮食文化绵延数千年，形成了独特而丰富的烹饪体系。在传承中创新，在创新中传承，当代中餐正在经历一场令人振奋的现代化变革。</p>
    <h3>传统技法的现代演绎</h3>
    <p>米其林星级中餐厨师们正在用现代烹饪技术重新诠释传统菜品。低温慢煮、分子料理等现代技法与传统中餐烹饪理念相结合，创造出既保留传统味道又具有现代美学的新派中餐。</p>
    <h3>地方菜系的文化复兴</h3>
    <p>从川菜的麻辣鲜香到粤菜的清淡鲜美，从淮扬菜的精致典雅到鲁菜的大气磅礴，地方菜系的文化价值正在被重新认识和发掘。越来越多的年轻人开始学习传统烹饪技艺，将家乡的味道传承下去。</p>
    <h3>饮食与健康的深度融合</h3>
    <p>中医药膳理念与现代营养学相结合，催生了一种全新的健康饮食方式。根据季节变化、个人体质调整饮食结构，这种源于中国传统智慧的健康理念正在获得越来越多的科学验证和公众认可。</p>
    <p>中国传统饮食文化的魅力在于它的包容性和创造力。在传统与创新的交汇处，中餐正在书写新的传奇。</p>`,
    category: '生活美学',
    categorySlug: 'shenghuo',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20Chinese%20cuisine%20plating%20on%20ceramic%20dish%2C%20restaurant%20setting%20with%20warm%20lighting%2C%20artistic%20food%20photography%2C%20cultural%20aesthetic&width=800&height=500&seq=article-shenghuo-2&orientation=landscape',
    author: '陈美琳',
    date: '2025-12-12',
    views: 69400,
    tags: ['中餐文化', '传统美食', '新派中餐', '饮食健康'],
    readTime: 7,
  },
  {
    slug: 'tangshi-songci-xiandai-jiazhi',
    title: '唐诗宋词的当代价值：千年诗意如何照亮现代生活',
    excerpt: '唐诗宋词不仅是中华文化的瑰宝，更蕴含着穿越时空的人生智慧。在快节奏的现代生活中，古典诗词能为我们带来怎样的精神滋养？',
    content: `<p>"床前明月光，疑是地上霜"，"大江东去，浪淘尽，千古风流人物"——这些传诵千年的诗句，至今仍能直击人心。唐诗宋词的价值不仅在于其文学成就，更在于其中蕴含的人生智慧和情感共鸣。</p>
    <h3>诗词中的生活哲学</h3>
    <p>李白的"天生我材必有用"激励着无数人相信自己的价值；苏轼的"人生如逆旅，我亦是行人"教会我们豁达面对人生起伏。这些穿越千年的智慧箴言，在今天依然能够给我们以启迪和安慰。</p>
    <h3>诗词美育的当代实践</h3>
    <p>越来越多的学校和家庭开始重视古典诗词的美育功能。通过诵读、赏析和创作，孩子们不仅学习语言表达，更在潜移默化中接受美的熏陶。诗词教育正在成为培养文化自信的重要途径。</p>
    <h3>数字时代的诗词新生</h3>
    <p>短视频平台上的诗词诵读、AI诗词创作工具、互动式诗词学习应用……数字技术正在为古典诗词注入新的活力。传统的诗词与现代科技的结合，让更多人能够以更加生动有趣的方式亲近古典文化。</p>
    <p>诗词之美，在于它能够穿越时空，连接古今。在这份跨越千年的诗意中，我们找到了安顿心灵的归处。</p>`,
    category: '历史人文',
    categorySlug: 'lishi',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20calligraphy%20and%20poetry%20scrolls%20on%20aged%20paper%20with%20ink%20brush%2C%20traditional%20scholar%20study%2C%20warm%20candlelight%2C%20cultural%20heritage%20photography&width=800&height=500&seq=article-lishi-2&orientation=landscape',
    author: '孙雅文',
    date: '2025-11-22',
    views: 58900,
    tags: ['唐诗宋词', '传统文化', '古典诗词', '文化传承'],
    readTime: 7,
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.categorySlug === categorySlug);
}

export function getRelatedArticles(currentSlug: string, categorySlug: string, limit: number = 3): Article[] {
  return articles
    .filter((a) => a.categorySlug === categorySlug && a.slug !== currentSlug)
    .slice(0, limit);
}

export function getLatestArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
}

export function getPopularArticles(limit: number = 4): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit);
}